var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "required-fields-advice-container" }, [
    _setup.props.showRequiredFieldsAdvice
      ? _c("span", { staticClass: "required-fields-advice" }, [
          _vm._v(_vm._s(_setup.legend)),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }